import axiosInstance from "./axios-order";
import Cookies from "js-cookie";
import {toast} from "react-toastify";
import {REQ_TYPES} from "@/constants/general-constants";
import * as cookie from "cookie";
import Link from "next/link";

export const fetchData = async (url = isRequired("url"), type = isRequired("type"), dataParams = {}, token = false, props = {}) => {

    const {
        isHeaderJson = false,
        isLoader = true,
        uploadProgress = () => {
        },
        existFile = false,
        reFetchCallback = null,
        inputParams = [],
        axiosConfig = {},
        headerConfigs = {},
    } = props;

    if (typeof window !== 'undefined' && !navigator.onLine) {
        toast.error('خطا در دسترسی به اینترنت');

        const reRequest = () => {
            if (typeof reFetchCallback === "function") {
                reFetchCallback();
            }
            window.removeEventListener('online', reRequest);
        }

        window.addEventListener('online', reRequest);

        return {error: true};
    }

    if (isLoader) {
        loader(true)
    }

    //Initial headers
    let header = {...headerConfigs}

    if (existFile) {
        header = {...header, "Content-Type": "multipart/form-data; boundary"}
    } else if (isHeaderJson) {
        header = {...header, "Content-Type": "application/json; charset=utf-8"}
    }

    //Generate final header
    if (token) {
        const tokenValue = typeof token === "string" ? token : Cookies.get(process.env.NEXT_PUBLIC_FREELANCER_TOK);

        header = {
            headers: {
                ...header,
                Authorization: `Bearer ${tokenValue ? tokenValue : cookie.parse(token.toString())[process.env.NEXT_PUBLIC_FREELANCER_TOK]}`
            }
        };
    } else {
        header = {
            headers: {
                ...header,
            }
        };
    }

    const requestConfig = {
        ...header,
        ...axiosConfig
    }

    if (type === REQ_TYPES.POST) {
        let formData;
        if (isHeaderJson) {
            formData = dataParams;
        } else if (existFile) {
            formData = new FormData();
            for (let key in dataParams) {
                formData.append(key, dataParams[key])
            }
        } else {
            formData = new URLSearchParams();
            for (let key in dataParams) {
                formData.append(key, dataParams[key])
            }
        }
        try {

            const {data, status} = token ? await axiosInstance.post(url, formData, {
                ...requestConfig,
                onUploadProgress: uploadProgress,
            }) : await axiosInstance.post(url, formData, requestConfig);

            if (isLoader) {
                loader(false);
            }
            return responseHandler(data, status, reFetchCallback, inputParams)

        } catch (errorData) {
            if (isLoader) {
                loader(false);
            }
            return responseHandler(errorData, null, reFetchCallback, inputParams)
        }

    } else {
        let formData = "?";
        for (let key in dataParams) {
            formData += formData.slice(-1) === "?" ? `${key}=${dataParams[key]}` : `&${key}=${dataParams[key]}`;
        }

        try {
            const {
                data,
                status
            } = token ? await axiosInstance.get(url + formData, requestConfig) :
                await axiosInstance.get(url + formData, requestConfig);
            if (isLoader) {
                loader(false);
            }

            return responseHandler(data, status, reFetchCallback, inputParams)

        } catch (errorData) {
            if (isLoader) {
                loader(false);
            }
            return responseHandler(errorData, null, reFetchCallback, inputParams)
        }

    }
};

const responseHandler = (data, status, reFetchCallback, inputParams) => {

    const statusCode = status || (data.response && data.response.status) || data.code;
    //After ask data.errors
    const error = data.errors || (data.response && data.response.data && data.response.data.error);

    console.log("FETCH DATA FUNC: ", data)

    if (statusCode === 200) {
        return {data, error: null};
    }

    return errorHandler(error, reFetchCallback, statusCode)

    // if (statusCode >= 400 && statusCode <= 499) {
    //     if (errors) {
    //         // errors are array and handled as array
    //         return errorMessageHandler(errors, reFetchCallback, statusCode, inputParams)
    //     } else {
    //         return errorMessageHandler("خطای ناخواسته ای پیش آمد", reFetchCallback, statusCode, inputParams, data)
    //         //خطای ناخواسته ای پیش آمد
    //     }
    // }
    //
    // return errorMessageHandler("خطای سمت سرور", reFetchCallback, statusCode, inputParams, data);


    // if (e.response.status === 401) {
    //     localStorage.removeItem(process.env.NEXT_PUBLIC_FREELANCER_TOK);
    //     window.location.replace("/login");

    // } else if (e.response.status === 403) {
    //     //Not handled
    //     for (let key in e.response.data.errors) {
    //         errorMessageHandler(e.response.data.errors[key].message)
    //     }
    //     setTimeout(() => {
    //         window.location.replace("/dashboard");
    //     }, 3000)
    // }

}

const errorHandler = async (error, reFetchCallback, statusCode) => {
    //reFetchCallback just called on the client side request

    const {message = "خطای ناخواسته ای پیش آمد"} = error || {};

    if (typeof window !== 'undefined') { //Client side
        if (!errorCodeHandler(statusCode, reFetchCallback)) {
            toast.error(message);
        }
        return {error: error === undefined ? true : error}; //In CANCELED_ERR
        //Object or null
        // if (error) {
        //     // toast.error(error.errors.length ? error.errors[0] : message)
        //     toast.error(message)
        // } else {
        //     toast.error(message);
        // }
    } else { //Server side
        return {
            error: {
                message,
                error: error ? error : null,
                statusCode: statusCode ? statusCode : 500,
                reFetchCallback
            }
        };
    }
}

export const errorCodeHandler = (statusCode, callback = () => {}) => {
    switch (true) {
        case statusCode === 401: {
            toast.error(<div><p>عدم دسترسی </p><Link className="font-bold" style={{textDecoration: "underline"}} href="/login/employer">وارد شوید</Link></div>)
            //Development
            // Cookies.remove(process.env.NEXT_PUBLIC_FREELANCER_TOK);
            Cookies.remove(process.env.NEXT_PUBLIC_FREELANCER_TOK, {
                domain: `.${process.env.NEXT_PUBLIC_MAIN_URL}`
            });
            // await Router.replace("/login")
            // window.location.replace("/");
            return true;
        }

        case statusCode === 404 : {
            // window.location.replace("/404");
            toast.error('صفحه مورد نظر پیدا نشد')
            return true;
        }

        case statusCode >= 500: {
            toast.error('خطای سمت سرور');
            DataReFetchHandler(callback);
            return true;
        }

        case statusCode === "ERR_CANCELED": {
            return true; //No need to toast
        }

        default:
            return false;
    }
}

export const DataReFetchHandler = (reFetchFunc) => {

    try {
        const reFetchContainer = document.getElementById('re-fetch-container');
        reFetchContainer.classList.remove('hidden');
        reFetchContainer.classList.add('flex');
        document.getElementById('re-fetch-btn').onclick = () => {
            typeof reFetchFunc === "function" ? reFetchFunc() : window.location.reload();
        }

        return true
    } catch (e) {
        return false
    }
}

export const errorRedirectHandler = (error) => {
    if (!error) return {};

    const {statusCode} = error;
    if (statusCode === 404) {
        return {
            redirect: {
                destination: "/404"
            }
        }
    } else if (statusCode === 401) {
        return {
            redirect: {
                destination: "/login/freelancer"
            }
        }
    } else {
        return {}
    }
}

export const loader = (status = false) => {
    try {
        // status ? document.getElementById('loader').classList.remove('d-none')
        //     : document.getElementById('loader').classList.add('d-none');
    } catch (e) {
    }
};

export const isEmpty = (obj) => {

    if (!obj) return true;

    for (let prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            return false;
        }
    }

    return JSON.stringify(obj) === JSON.stringify({});
};

export const copyToClipboard = async (textToCopy) => {
    // Navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(textToCopy);
        toast.success("لینک کپی شد!");
    } else {
        // Use the 'out of viewport hidden text area' trick
        const textArea = document.createElement("textarea");
        textArea.value = textToCopy;

        // Move textarea out of the viewport so it's not visible
        textArea.style.position = "absolute";
        textArea.style.left = "-999999px";

        document.body.prepend(textArea);
        textArea.select();

        try {
            document.execCommand('copy');
            toast.success("لینک کپی شد!");
        } catch (error) {
            toast.error("خطا در کپی کردن متن");
        } finally {
            textArea.remove();
        }
    }
}

export const getValidNumber = (str) => {
    let
        persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
        arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    if (typeof str === 'string') {
        for (let i = 0; i < 10; i++) {
            str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
        }
    }
    return str;
};

export const isRequired = param => {
    throw new Error(`${param} is required`);
};

export const getPriceFormat = (x) => {
    if (!x)
        return 0;

    try {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } catch (e) {
        return 0
    }
}


export const getDiscountPercentage = (price, discount_price) => {
    price = parseInt(price);
    discount_price = parseInt(discount_price);

    if (discount_price !== 0 && discount_price < price) {
        return parseInt((price - discount_price) * 100 / price);
    }
    return 0;
};

export const isJson = (str) => {
    if (str === "false" || str === "true") return false;
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}


export const generatePageItem = (data, currentPage = 1, maxPageCount = 5) => {
    const {per_page, total_data} = data || {};
    const pageCount = Math.ceil(total_data / (per_page || 1)); //Prevent divided to zero
    let pages = [];

    if (pageCount > 1) {
        if (pageCount > maxPageCount) {
            let isFirstOrLastPage = currentPage === 1 || currentPage === pageCount;
            const halfPageCount = Math.floor(pageCount / 2);
            const halfMaxPageCount = Math.floor(maxPageCount / 2);

            if (isFirstOrLastPage) {
                for (let i = 0; i < maxPageCount; i++) {
                    let page = null;
                    page = (i === halfMaxPageCount) ? null :
                        i + 1 < halfPageCount ? i + 1 : pageCount - (maxPageCount - (i + 1))
                    pages.push({
                        page,
                        active: currentPage === page
                    })
                }
            } else {
                let matchedPage = false
                for (let i = 0; i < halfMaxPageCount; i++) {
                    let active = currentPage === i + 1;
                    if (active) {
                        matchedPage = true;
                    }
                    pages.push({
                        page: i + 1,
                        active
                    })
                }
                pages.push({
                    page: null,
                    active: false
                })
                for (let i = 0; i < halfMaxPageCount; i++) {
                    let page = pageCount - (halfMaxPageCount - (i + 1))
                    let active = currentPage === page;
                    if (active) {
                        matchedPage = true;
                    }
                    pages.push({
                        page,
                        active
                    })
                }
                if (!matchedPage) {
                    pages.push({
                        page: currentPage,
                        active: true
                    })

                    pages = pages.sort((a, b) => a.page - b.page)
                    const nullPage = pages.shift();

                    const sortedPages = [];
                    for (let value of pages) {
                        if (value.page === currentPage) {
                            sortedPages.pop();
                            sortedPages.push(value);
                            sortedPages.push(nullPage);
                        } else {
                            sortedPages.push(value)
                        }
                    }
                    pages = sortedPages;
                }
            }
        } else {
            for (let i = 0; i < pageCount; i++) {
                pages.push({
                    page: i + 1,
                    active: i + 1 === currentPage
                })
            }
        }
    }

    return pages;

}


export const getNumberWithGap = (number, gap = 2) => {
    return ("0" + number).slice(-gap);
};

export const generateSearchQuery = (obj) => {
    let searchQuery = '?';

    for (let key in obj) {
        if (obj[key]) {
            searchQuery += `${key}=${obj[key]}&`;
        }
    }

    return searchQuery.slice(0, -1);
}

export const addQueryToUrl = (url = "", prevQueryParams, newQueryParams = {}) => {
    let newParams = "?"
    let joinedParams;

    if(prevQueryParams) {
        joinedParams = {
            ...prevQueryParams,
            ...newQueryParams
        }
    } else {
        joinedParams = {
        ...newQueryParams
        }
    }

    let i = 0;
    for (let key in joinedParams) {
        if(i !== 0) newParams += '&';
        newParams += `${key}=${joinedParams[key]}`;
        i++;
    }

    return url + newParams
}

// export const getPersianDate = (date, format = 'YYYY-MM-DD') => {
//     if (!date) return '';
//     return new DateObject(date).convert(persian).setLocale(persian_fa).format(format)
// }


// export const getDiffDays = (firstDate, secondDate) => {
//     if (!firstDate || !secondDate) return '0';
//
//     const start = moment(firstDate, "YYYY-MM-DD");
//     const end = moment(secondDate, "YYYY-MM-DD");
//
//     // const firstDateObj = new DateObject(firstDate);
//     // const secondDateObj = new DateObject(secondDate);
//
//     // const firstDateArray = [firstDateObj.format('YYYY'), firstDateObj.format('MM'), firstDateObj.format('DD')]
//     // const secondDateArray = [secondDateObj.format('YYYY'), secondDateObj.format('MM'), secondDateObj.format('DD')];
//
//     return moment.duration(start.diff(end)).asDays()
//     // moment(firstDateArray).diff(moment(secondDateArray), 'days');
// }


export const getCodeMode = (code = "", placeholder = "-", codeLength = 4) => {

    for (let i = code.length; i < codeLength; i++) {
        code += placeholder;
    }

    return code;
}

export const getPercentagePrice = (discount, totalPrice) => {
    if (!!!Number(discount) || !!!Number(totalPrice)) {
        return 0;
    }

    return Math.floor((totalPrice / 100) * discount)
}
